import React, { useState } from 'react';
import Problema from '../../../../assets/images/wifi6e-Photoroom.png';
import Sinal from '../../../../assets/images/wifi6.png';
import Card from 'react-bootstrap/Card';

import 'bootstrap/dist/css/bootstrap.min.css';

function Wifi6() {
  return (
    <>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-sm-12 col-md-6'>
            <h1>Tecnologias - Wi-Fi 6 e Wi-Fi 6E</h1>
            <img src={Problema} alt='problema' className='mb-0' />
            <Card className="text-center">
              <Card.Header>
                Oferecem maior velocidade e capacidade, suportando mais dispositivos simultaneamente.
              </Card.Header>
              <Card.Body>
                {/* <Card.Title>Coleta de Informações e Análise do Ambiente</Card.Title> */}
                <Card.Text>
                  <div className='opcoes'>
                    <div>
                      <strong>1. Wi-Fi 6 (802.11ax): </strong>
                      Wi-Fi 6, também conhecido como 802.11ax, é a nova geração de tecnologia de redes sem fio,
                      projetada para melhorar a velocidade, a capacidade e a eficiência das redes Wi-Fi.
                      Proporciona velocidades até 40% maiores em comparação com o Wi-Fi 5, essa melhoria é proporcionada
                      pelo uso de tecnologias como OFDMA, MU-MIMO, QAM, BSS, etc.

                    </div>
                    <br />
                    <div>
                      <strong>2. Wi-Fi 6E: </strong>
                      Wi-Fi 6E é uma extensão do Wi-Fi 6 que opera na faixa de 6GHz,
                      além das bandas de 2.4 GHz e 5 GHz usadas pelas
                      gerações anteriores de Wi-Fi. Essa expansão para a banda de 6GHz traz
                      benefícios como de menor latência e maior largura de banda em comparação com as bandas de 2,4 GHz e 5 GHz.
                    </div>
                    <br />
                    <div>
                      <strong>3.Comparação da cobertura do sinal em diferentes Frequências: </strong><br />
                      <strong>Frequência de 2.4 GHz:</strong><br />
                      Alcance em ambientes internos: Aproximadamente 35 metros<br />
                      Alcance em ambientes externos: Aproximadamente 90 metros<br />
                      <strong>Frequência de 5 GHz:</strong><br />
                      Alcance em ambientes internos: Aproximadamente 10-15 metros<br />
                      Alcance em ambientes externos: Aproximadamente 30-50 metros<br />
                      <strong>Frequência de 6 GHz:</strong><br />
                      Alcance em ambientes internos: Aproximadamente 8-12 metros<br />
                      Alcance em ambientes externos: Aproximadamente 25-35 metros
                    </div>

                  </div>
                </Card.Text>
                {/* <Button variant="primary">Go somewhere</Button> */}
              </Card.Body>
              <Card.Footer className="text-muted">

              </Card.Footer>
            </Card>

          </div>
          <div className='col-sm-12 col-md-6'>
            <div className='imagem'>
              <img className="d-block w-100" src={Sinal} alt="Current slide" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Wifi6;
